import React from 'react';
import styled, { css } from 'styled-components';

import { FadeIn } from './animations/FadeIn';
import { Message } from './common/CommonStyles';
import { Spinner } from './common/Spinner';

interface MainLoaderProps {
	message: JSX.Element;
}

export class MainLoader extends React.Component<MainLoaderProps, {}> {
	render() {
		return (
			<Container>
				<Spinner dotStyle={{ size: '1rem', margin: '.66rem' }} />
				<Message>{this.props.message}</Message>
			</Container>
		);
	}
}

const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	animation: ${css`
			${FadeIn}`} 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) forwards;
`;
